import { tint } from "./textStyles";
import { isDarkTheme, isNeonTheme } from "./themeTraits";

// The edge and shadow of a card in the guest funnel: the supply cards and the provider cards.
//
// `futuristic` (herevr): the neon is on the edge of the card and nowhere else — a lit
// border and the glow it throws outwards. The inside stays the tenant's section colour: an
// accent gradient across the card as well tinted the text, the price and the photo blue.
// Pointer-over turns the edge up.
//
// `default` (brownsbs) keeps the plain shadowed card it always had: neon on that tenant's
// paper theme would be a different site.
const neonSx = (displayConfig) => {
  const accent = displayConfig?.primaryColor;

  return {
    border: `1px solid ${tint(accent, 0.6)}`,
    boxShadow: `0 0 16px ${tint(accent, 0.32)}`,
    "&:hover": {
      borderColor: tint(accent, 0.9),
      boxShadow: `0 0 26px ${tint(accent, 0.55)}`,
    },
  };
};

// `dark` (2fadedbarbershop): the neon card's frame without the light. A hairline in the accent
// colour that turns solid on pointer-over, on a plain black shadow.
const hairlineSx = (displayConfig) => {
  const accent = displayConfig?.primaryColor;

  return {
    border: `1px solid ${tint(accent, 0.35)}`,
    boxShadow: `0 12px 28px -18px ${tint("#000", 0.9)}`,
    "&:hover": {
      borderColor: accent,
      boxShadow: `0 16px 32px -18px ${tint("#000", 1)}`,
    },
  };
};

const paperSx = () => ({
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
  "&:hover": { boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)" },
});

export const cardSurfaceSx = (displayConfig) => {
  if (isNeonTheme(displayConfig)) return neonSx(displayConfig);
  return isDarkTheme(displayConfig) ? hairlineSx(displayConfig) : paperSx();
};
